export default __webpack_public_path__ + "static/media/p_wdt_c_0_1.846ca398.mp3";